import React from "react"
import SlideCard from "./SlideCard"

const SliderHome = () => {
  return (
    <>
      <section className='homeSlide contentWidth mp'>
        
          <SlideCard />
       
      </section>
    </>
  )
}

export default SliderHome
